document.addEventListener('DOMContentLoaded', function () {
  if (window.location.href.includes('apps/customers')) {
    (function () {
      const intervalId = setInterval(() => {
        const carouselContent = document.querySelector('.__carousel_content');
        if (
          carouselContent &&
          carouselContent.parentElement?.parentElement
        ) {
          document.querySelector('.__carousel_content').parentElement.parentElement.previousSibling.style.display = 'none';
          document.querySelector('.__carousel_content').parentElement.parentElement.style.display = 'none';
          clearInterval(intervalId);
        }
      }, 400);
      setTimeout(() => {
        clearInterval(intervalId);
        console.log('Stopped checking for __carousel_content after 20 seconds');
      }, 20000);
    })();
  }
});
